import InputBox from "../../../../common/interactive/InputBox"
import CheckboxCell from "../../../../common/interactive/CheckboxCell"
import DatepickerWithLabel from "../../../../common/interactive/DatepickerWithLabel"
import classes from './PreoperativeTestsRepeaterItem.module.css'

export default function PreoperativeTestsRepeaterItem({addItemData, id, itemData}) {

    function addNewItemHandler(value) {
        if (addItemData) {
            addItemData(value)
        }
    }

    return <div className={classes.item}>
        <div style={{width: 160}}>
            <InputBox label={'Name'} currentValue={itemData.name} action={addNewItemHandler} identifier={{type: null, field: 'name', type_id: null, folder: null, repeater_id: id}} />
        </div>
        <div className='flex-container' style={{width: 140}}>
            <CheckboxCell action={addNewItemHandler} checked={itemData.requested} direction={'centered'} identifier={{type: null, field: 'requested', type_id: null, folder: null, repeater_id: id, isCheckbox: true}}/>
            <DatepickerWithLabel textRight={true} label={''} defaultDate={itemData.requested_date} setStyle={'simple'} action={addNewItemHandler} identifier={{type: null, field: 'requested_date', type_id: null, folder: null, repeater_id: id}}/>
        </div>
        <div className='flex-container' style={{width: 140}}>
            <CheckboxCell action={addNewItemHandler} checked={itemData.obtained} direction={'centered'} identifier={{type: null, field: 'obtained', type_id: null, folder: null, repeater_id: id, isCheckbox: true}}/>
            <DatepickerWithLabel textRight={true} label={''} defaultDate={itemData.obtained_date} setStyle={'simple'} action={addNewItemHandler} identifier={{type: null, field: 'obtained_date', type_id: null, folder: null, repeater_id: id}}/>
        </div>
    </div>
}
